
namespace GeniuzPOS.InventoryReport {

    @Serenity.Decorators.registerClass()
    export class IcReportWhsEomGrid extends Serenity.EntityGrid<IcReportWhsEomRow, any> {
        protected getColumnsKey() { return IcReportWhsEomColumns.columnsKey; }
        protected getDialogType() { return IcReportWhsEomDialog; }
        protected getIdProperty() { return IcReportWhsEomRow.idProperty; }
        protected getInsertPermission() { return IcReportWhsEomRow.insertPermission; }
        protected getLocalTextPrefix() { return IcReportWhsEomRow.localTextPrefix; }
        protected getService() { return IcReportWhsEomService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }


        
    }
}